import { render, staticRenderFns } from "./DeveloperManageGroup.vue?vue&type=template&id=38f34409"
import script from "./DeveloperManageGroup.vue?vue&type=script&lang=js"
export * from "./DeveloperManageGroup.vue?vue&type=script&lang=js"
import style0 from "./DeveloperManageGroup.vue?vue&type=style&index=0&id=38f34409&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports